export function fileUploading() {
  let $fileList = $(".fileList");
  $.fn.fileUploader = function (filesToUpload) {
    this.closest(".files").change(function (evt) {
      for (let i = 0; i < evt.target.files.length; i++) {
        filesToUpload.push(evt.target.files[i]);
      }
      let output = [];
      for (let i = 0, f; f = evt.target.files[i]; i++) {
        output.push("<li><span>", escape(f.name), "</span></li>");
      }
      $(this).children(".fileList").append(output.join(""));
      if (!$(this).find(".removeFiles").length) {
        $(this).prepend("<button class=\"removeFiles btn btn-danger\">Clear All</button>");
      }
    });
  };

  $(document).on("click", ".removeFiles", function (e) {
    e.preventDefault();
    $("input#file").val("");
    $fileList.html("");
    setTimeout(() => {
      $(".removeFiles").remove();
    }, 500);
  });

  document.addEventListener("wpcf7mailsent", function (event) {
    $fileList.html("");
  }, false);

  let filesToUpload = [];
  $("#files").fileUploader(filesToUpload);
}


// WEBPACK FOOTER //
// ./assets/js/modules/fileUploading.js